import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import encrypt from '../../utils/jsencrypt';
import { Button, Row, Form, Input,message } from 'antd'
const FormItem = Form.Item;
class DefaultPage extends Component {
  static propTypes = {
    login: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  state = {
    uuid: '',
    img: ''
  }
  componentDidMount() {
    
    // let token = sessionStorage.getItem("token");
    // console.log(token)
    // if(!token) {
    //   window.open('/login')
    // }
    const { actions } = this.props
    const { getCodeImageActions } = actions
    getCodeImageActions().then(() => {
      const { codeImageId, codeImage } = this.props.login
      this.setState({
        uuid: codeImageId,
        img: codeImage
      })
      // console.log(this.state.uuid,this.state.img)
    })
   
  }

  handleSearch = () => {
    window.open('/gkproduct/ProductDetail')
  }
  handleOk = () => {
    const { actions, form } = this.props
    const { validateFieldsAndScroll } = form;
    const { loginActions } = actions;



    validateFieldsAndScroll((errors, values) => {
      if (errors) {
        return
      }



      let params = {
        username: values.username,
        password: encrypt(values.password),
        code: values.code,
        uuid: this.state.uuid
      }
      console.log('param', params);
      loginActions(params).then((res) => {
        console.log(res)
      });

      // dispatch({ type: 'login/login', payload: values })
    })
  }
  handleCutImg = () => {
    const { getCodeImageActions } = this.props.actions
    getCodeImageActions().then(() => {
      const { codeImageId, codeImage } = this.props.login
      this.setState({
        uuid: codeImageId,
        img: codeImage
      })
    }).catch((res) => {
      console.log(res)
    })
  }
  render() {
    const { form } = this.props
    const { getFieldDecorator } = form
    return (
      <Fragment>
        <div className="form">
          <div className="logo">
            <span>管理后台</span>
          </div>
          <form>
            <FormItem hasFeedback>
              {getFieldDecorator('username', {
                rules: [
                  {
                    required: true,
                  },
                ],
              })(
                <Input
                  onPressEnter={this.handleOk}
                  placeholder="请输入用户名"
                />
                )}
            </FormItem>

            <FormItem hasFeedback>
              {getFieldDecorator('password', {
                rules: [
                  {
                    required: true,
                  },
                ],
              })(
                <Input
                  type="password"
                  onPressEnter={this.handleOk}
                  placeholder="请输入密码"
                />
                )}
            </FormItem>

            <FormItem hasFeedback>
              {getFieldDecorator('code', {
                rules: [
                  {
                    required: true,
                  },
                ],
              })(
                <Input
                  type="code"
                  onPressEnter={this.handleOk}
                  placeholder="请输入验证码"
                />
                )}
            </FormItem>
            <img onClick={this.handleCutImg} className="codeImg" src={this.state.img} />

            <Row>
              <Button
                type="primary"
                onClick={this.handleOk}
              >
                登录
              </Button>
            </Row>

            <Row className='button_botton'>
              <Button
                type="primary"
                onClick={this.handleSearch}
              >
                公共查询
              </Button>
            </Row>
          </form>
        </div>
        <div className="footer">
        </div>
      </Fragment>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    login: state.login,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

const WrappedNormalLoginForm = Form.create({ name: 'normal_login' })(DefaultPage);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WrappedNormalLoginForm);



// WEBPACK FOOTER //
// ./src/features/login/DefaultPage.js